var Types = /*#__PURE__*/function (Types) {
  Types["blockQuote"] = "block-quote";
  Types["bulletedList"] = "bulleted-list";
  Types["numberedList"] = "numbered-list";
  Types["editableVoid"] = "editable-void";
  Types["heading"] = "heading";
  Types["headingOne"] = "heading-one";
  Types["headingTwo"] = "heading-two";
  Types["image"] = "image";
  Types["img"] = "img";
  Types["link"] = "link";
  Types["button"] = "button";
  Types["listItem"] = "list-item";
  Types["paragraph"] = "paragraph";
  Types["div"] = "div";
  Types["span"] = "span";
  Types["codeBlock"] = "code-block";
  Types["codeLine"] = "code-line";
  Types["iframe"] = "iframe";
  return Types;
}({});
export { Types };